import { render, staticRenderFns } from "./AbortoProcessoModal.vue?vue&type=template&id=d020b5d2&scoped=true&"
import script from "./AbortoProcessoModal.vue?vue&type=script&lang=js&"
export * from "./AbortoProcessoModal.vue?vue&type=script&lang=js&"
import style0 from "./AbortoProcessoModal.vue?vue&type=style&index=0&id=d020b5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d020b5d2",
  null
  
)

export default component.exports